export var lineHeight = {
    auto: "auto",
    tight: "0.95",
    snug: "1.1",
    normal: "1.2",
    relaxed: "1.5",
    extra: "1.8"
};

//# sourceMappingURL=lineHeight.js.map